import { Box, useColorModeValue } from '@chakra-ui/react';
import * as React from 'react';
import { useStep } from './useStep';

export const StepConnector = () => {
  const { isCompleted } = useStep();
  const accentColor = useColorModeValue('brand.500', 'brand.300');

  return (
    <Box
      borderStartWidth='1px'
      borderStartColor={isCompleted ? accentColor : 'inherit'}
      height={6}
      mb={0}
      ms='4'
      ps='4'
    />
  );
};
